import { call, takeLatest, all, put, select } from 'redux-saga/effects';
import api from 'services/api';

import { Types, Creators } from 'store/ducks/blog/category/insert';
import { callApi } from 'store/sagas/auth';

import { push } from 'connected-react-router';
import Notifications from 'react-notification-system-redux';

const readFile = file =>
  new Promise(resolve => {
    const reader = new FileReader();
    reader.onloadend = () => {
      resolve(reader.result);
    };
    reader.readAsDataURL(file);
  });

function* getCategoryImageUpload(payload) {
  try {
    const { id, image_data } = payload;
    const imageBase64 = yield call(readFile, image_data);
    const data = {
      image: imageBase64,
    };
    const response = yield call(
      api.post,
      `/v1/admin/blogs/categories/${id}/images`,
      data,
    );
    return true;
  } catch (err) {
    return false;
  }
}

function* getCategoryInsert({ payload }) {
  try {
    const { name, image_data, status } = payload;
    const request = call(api.post, '/v1/admin/blogs/categories', {
      name,
      image_data,
    });
    const response = yield call(callApi, request);
    const { id } = response.data.data;
    yield getCategoryImageUpload({ id, image_data, status });
    yield put(Creators.getCategoryInsertSuccess());
    yield put(
      Notifications.success({ title: 'Cadastro concluido com sucesso' }),
    );
    yield put(push(`/blog/categories/update/${id}`));
  } catch (err) {
    yield put(Creators.getCategoryInsertFailure('Erro ao buscar na API'));
  }
}

// Individual exports for testing
export default function* productListSaga() {
  yield all([takeLatest(Types.GET_INSERT_REQUEST, getCategoryInsert)]);
}
